<template>
  <hero-navigation>
    <div class="projects-nav-elements">
      <router-link class="button-outline-blue" to="/expenses/backlink">
        Expenses Backlink
      </router-link>
      <router-link class="button-outline-blue" to="/expenses/content">
        Expenses Content
      </router-link>
      <router-link class="button-outline-blue" to="/expenses/ppc">
        Expenses PPC
      </router-link>
    </div>
  </hero-navigation>
</template>
<script>
import HeroNavigation from '../components/HeroNavigation.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'expenses-navigation',
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['me', 'isAdmin', 'isManager', 'isManagerAndBigger'])
  },
  components: {
    HeroNavigation
  }
}
</script>
